<button #focusableEleTop class="focusable-element"></button>
<div class="row" *ngIf="hasError">
    <div class="col-24">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul>
                <li *ngFor="let error of ErrorMessages"><button>{{ error }}</button></li>
            </ul>
        </div>
    </div>
</div>
<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<form (keydown)="onKeyDown($event)">
    <EnrollmentApplicationClient [enDetail]="enrollmentViewModel"
                                 (onValueChange)="onAgreeChange($event)">

    </EnrollmentApplicationClient>
    <div class="row">
        <div class="col-24">
            <span *ngIf="isValidAgent">
                <button class="button primary" (click)="onSubmit()">Send Email</button>

            </span>
            <span *ngIf="finalsubmit">
                <button class="button primary" (click)="onSubmitmyApp()">Submit my application</button>
                <button class="button cancel" (click)="btnBack()">Go Back</button>
                <button id="continueEAP" class="button primary" (click)="rejectStep()">I've changed my mind. Reject and cancel this application process.</button>
            </span>
            <span *ngIf="!finalsubmit">
                <button class="button cancel" (click)="btnPrevious()">Go Back</button>
            </span>

        </div>
    </div>
</form>
